export const OrderTemplateEvents = {
  productRemoved: 'article-removed-from-template',
  templateCreated: 'order-template-created'
};
